import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-datasource-publish-success-modal .tb-datasource-publish-details', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    padding: '18px 35px',
    textAlign: 'left',
});

cssRule('.tb-datasource-publish-success-modal .tb-datasource-publish-details-popover-trigger', {
    textDecoration: 'underline',
});

cssRule('.tb-datasource-publish-success-modal .tb-datasource-publish-details-popover-info-icon', {
    display: 'inline-block',
    marginLeft: '-3px',
    width: '14px',
    height: '14px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/info_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-datasource-publish-success-modal .tb-datasource-publish-details-popover-info-icon:hover', {
    backgroundImage: 'url(img/info_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-datasource-publish-success-modal .tb-link-datasource', {
    height: '18px',
});

cssRule('.tb-datasource-publish-success-modal .tb-datasource-publish-name', {
    paddingBottom: '18px',
});

cssRule('.tb-datasource-publish-success-modal .tb-dialog-actions', {
    marginTop: '18px',
    textAlign: 'right',
    paddingBottom: '12px',
});

